export default __webpack_public_path__ + "static/myline_logo_orange_web-7faff3a7c66108faa5ef4e74cd70f368.jpg";